import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from '../../core.module';

@Component({
  selector: 'footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.less']
})
export class FooterComponent implements OnInit {

  constructor(
    public router: Router,
    public localStorageService: LocalStorageService,
  ) { }

  ngOnInit(): void {
  }


  navigateUrl(routerLink: string): void{
    this.localStorageService.remove('prevUrlFooter');
    this.localStorageService.set('prevUrlFooter',this.router.url);
    window.scrollTo(0, 0)
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigateByUrl(routerLink,{skipLocationChange:false});
  }
}
